function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { AuthStatus, useAuthContext } from "../../context";
import { logout } from '@isyc-react/oc-api/auth';
import { setDocumentLang } from '@isyc-react/core/utils/accessibility';
import { useApolloClient } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { nsauth } from "../../../i18n/namespaces";
import { getBrowserLang } from '@isyc-react/core/utils';
export const useLogout = config => {
  const {
    language = 'fr',
    navigatorLang = true
  } = config !== null && config !== void 0 ? config : {};
  const client = useApolloClient();
  const {
    i18n
  } = useTranslation(nsauth.common);
  const {
    setUserSession,
    urlLocale
  } = useAuthContext();
  const clientLogout = React.useCallback(() => new Promise((resolve, reject) => {
    logout().then(data => {
      var _urlLocale$current, _getBrowserLang;
      setUserSession(v => _objectSpread(_objectSpread({}, v), {}, {
        status: AuthStatus.NOT_LOGGED,
        user: null
      }));
      const lang = (_urlLocale$current = urlLocale.current) !== null && _urlLocale$current !== void 0 ? _urlLocale$current : navigatorLang ? (_getBrowserLang = getBrowserLang()) !== null && _getBrowserLang !== void 0 ? _getBrowserLang : language : language;
      if (lang) {
        setDocumentLang(lang);
        i18n.changeLanguage(lang);
      }
      client.clearStore();
      resolve(data);
    }).catch(e => reject(e));
  }), []);
  return {
    logout: clientLogout
  };
};